module.exports = "<p>alert works!</p>\r\n<span class=\"example-pizza-party\">\r\n        Pizza party!!! 🍕\r\n      </span>\r\n"